var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreparationLandingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2181,
    cy: 12.2181,
    r: 11.2181,
    fill: "#00A9CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_437_15752",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_437_15752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7963 19.5498C11.9321 18.7967 10.963 18.2103 9.88889 17.7905C8.81481 17.3708 7.68519 17.1424 6.5 17.1054V9.56832C7.68519 9.60536 8.82099 9.85524 9.90741 10.318C10.9938 10.7812 11.9568 11.4017 12.7963 12.1794C13.6358 11.4017 14.5988 10.7812 15.6852 10.318C16.7716 9.85524 17.9074 9.60536 19.0926 9.56832V17.1054C17.9074 17.1424 16.7778 17.3708 15.7037 17.7905C14.6296 18.2103 13.6605 18.7967 12.7963 19.5498ZM12.7963 18.1239C13.5741 17.556 14.4012 17.0962 15.2778 16.7446C16.1543 16.3925 17.0556 16.1609 17.9815 16.0498V10.8091C17.0432 10.9696 16.139 11.2873 15.2689 11.7624C14.3983 12.238 13.5741 12.8584 12.7963 13.6239C12.0185 12.8584 11.1946 12.238 10.3244 11.7624C9.45383 11.2873 8.54938 10.9696 7.61111 10.8091V16.0498C8.53704 16.1609 9.43827 16.3925 10.3148 16.7446C11.1914 17.0962 12.0185 17.556 12.7963 18.1239ZM12.7963 9.92018C12.0556 9.92018 11.423 9.65771 10.8985 9.13277C10.3736 8.60832 10.1111 7.97573 10.1111 7.23499C10.1111 6.49425 10.3736 5.86141 10.8985 5.33647C11.423 4.81203 12.0556 4.5498 12.7963 4.5498C13.537 4.5498 14.1696 4.81203 14.6941 5.33647C15.219 5.86141 15.4815 6.49425 15.4815 7.23499C15.4815 7.97573 15.219 8.60832 14.6941 9.13277C14.1696 9.65771 13.537 9.92018 12.7963 9.92018ZM12.7963 8.80906C13.2284 8.80906 13.5988 8.65474 13.9074 8.3461C14.216 8.03746 14.3704 7.66709 14.3704 7.23499C14.3704 6.80289 14.216 6.43252 13.9074 6.12388C13.5988 5.81524 13.2284 5.66092 12.7963 5.66092C12.3642 5.66092 11.9938 5.81524 11.6852 6.12388C11.3765 6.43252 11.2222 6.80289 11.2222 7.23499C11.2222 7.66709 11.3765 8.03746 11.6852 8.3461C11.9938 8.65474 12.3642 8.80906 12.7963 8.80906Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparationLandingIcon);
export default __webpack_public_path__ + "static/media/preparation-landing-icon.ad9e1e453cef80c4790172e19d061db8.svg";
export { ForwardRef as ReactComponent };